/**
 * Mapping of Article ID prefixes (Pubcode) to Production Editor emails.
 * Keys should be lowercase for case-insensitive matching.
 */
export const productionEditorMapping = {
  'aomd': 'Shobha.Fapal@wolterskluwer.com',
  'wjcs': 'pallavi.narsale@wolterskluwer.com',
  'sgmj': 'Mahesh.Sawant@wolterskluwer.com',
  'joacp': 'Neelam.Dsouza@wolterskluwer.com',
  'ijc': 'Santosh.Zagade@wolterskluwer.com',
  'ni': 'Sheetal.Hodge@wolterskluwer.com',
  'neurol-india': 'Sheetal.Hodge@wolterskluwer.com',
  'ijo': 'Mangesh.Kamble@wolterskluwer.com',
  'ija': 'Mubeen.Shaikh@wolterskluwer.com',
  'jfmpc': 'avinash.kakade@wolterskluwer.com',
  'ijn': 'vinayak.salunke@wolterskluwer.com',
  'lungindia': 'Hanumant.Pawar@wolterskluwer.com',
  'indianjpsychiatry': 'Mubeen.Shaikh@wolterskluwer.com',
  'crst': 'Shobha.Fapal@wolterskluwer.com',
  'jpgm': 'swapnil.joshi@wolterskluwer.com',
  'ijpm': 'Santosh.Zagade@wolterskluwer.com',
  'njcp': 'Ajit.Sutar@wolterskluwer.com',
  'jiaomr': 'vinayak.salunke@wolterskluwer.com',
  'sja': 'Mubeen.Shaikh@wolterskluwer.com',
  'aca': 'Neelam.Dsouza@wolterskluwer.com',
  'ijpvm': 'Neelam.Dsouza@wolterskluwer.com',
  'idoj': 'mangesh.kamble@wolterskluwer.com',
  'aian': 'Priti.Mahadik@wolterskluwer.com',
  'ijd': 'Santosh.Zagade@wolterskluwer.com',
  'ijem': 'Santosh.Zagade@wolterskluwer.com',
  'jdrysruhs': 'Dattaprasad.Kanuka@wolterskluwer.com',
  'jehp': 'Mahesh.Sawant@wolterskluwer.com',
  'jcrt': 'Santosh.Zagade@wolterskluwer.com',
  'jpbs': 'Hanumant.Pawar@wolterskluwer.com',
  'mjdrdypu': 'swapnil.joshi@wolterskluwer.com',
  'ipj': 'Swati.Veer@wolterskluwer.com',
  'jomfp': 'swapnil.joshi@wolterskluwer.com',
  'ijcm': 'Ajit.Sutar@wolterskluwer.com',
  'njms': 'Swati.Veer@wolterskluwer.com',
  'abr': 'Swati.Veer@wolterskluwer.com',
  'kjo': 'Ramakant.Bandbe@wolterskluwer.com',
  'tjosr': 'Neelam.Dsouza@wolterskluwer.com',
  'joc': 'Hanumant.Pawar@wolterskluwer.com',
  'jos': 'Mubeen.Shaikh@wolterskluwer.com',
  'ijdr': 'Satish.Sawant@wolterskluwer.com',
  'sjg': 'Mohammad.Sharique@wolterskluwer.com',
  'njbcs': 'Priyanka.Abhyankar@wolterskluwer.com',
  'ijnmr': 'Shobha.Fapal@wolterskluwer.com',
  'ijoem': 'Dattaprasad.Kanuka@wolterskluwer.com',
  'joacc': 'Mangesh.Kamble@wolterskluwer.com',
  'dshmj': 'vinayak.salunke@wolterskluwer.com',

};

/**
 * Get the production editor email for a given article ID.
 * Matches the longest prefix if multiple match.
 * @param {string} articleId
 * @returns {string|null} Email address or null if not found
 */
export const getProductionEditorEmail = (articleId) => {
  if (!articleId) return null;
  const lowerId = articleId.toLowerCase();

  // Find all matching keys (prefixes) and select the longest one
  const matchingKeys = Object.keys(productionEditorMapping).filter(key => lowerId.startsWith(key));

  if (matchingKeys.length === 0) return null;

  // Sort by length descending to get the longest match first
  const longestMatch = matchingKeys.sort((a, b) => b.length - a.length)[0];

  return productionEditorMapping[longestMatch];
};
